import { PUBLIC_SETTINGS_ACTIONS } from 'store/v1/public_settings/public_settings.constants.js';

export const getPublicSettings = (team_schema, availabilityRequestId) => {
  return {
    types: [
      PUBLIC_SETTINGS_ACTIONS.GET_PUBLIC_SETTINGS,
      PUBLIC_SETTINGS_ACTIONS.GET_PUBLIC_SETTINGS_SUCCESS,
      PUBLIC_SETTINGS_ACTIONS.GET_PUBLIC_SETTINGS_FAILURE
    ],
    promise: client =>
      client.get(`/resource-portal/teams/${team_schema}/settings`, {
        // Portal settings resolve for the request's workspace/team (locale, country, branding);
        // without the id the backend can only return the organization's global settings.
        params: { availabilityRequestId },
        isV2: true
      })
  };
};
